import SchedulingMobileMenu from './SchedulingMobileMenu';

export default SchedulingMobileMenu;